"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyCookie = exports.createHttpOnlyServerCookie = exports.createServerCookie = void 0;
var createServerCookie = function (name, data, expires) { return [
    name,
    data,
    { httpOnly: false, expires: expires, domain: ".vtm.be" },
]; };
exports.createServerCookie = createServerCookie;
var createHttpOnlyServerCookie = function (name, data, expires) { return [
    name,
    data,
    { httpOnly: true, expires: expires, domain: ".vtm.be" },
]; };
exports.createHttpOnlyServerCookie = createHttpOnlyServerCookie;
var createEmptyCookie = function (name) { return [
    name,
    "",
    { httpOnly: false, expires: new Date(0), domain: ".vtm.be" },
]; };
exports.createEmptyCookie = createEmptyCookie;
